import {request} from './client.js'

/**
 * @return {Promise<import('./types.js').AuthMeResponse>}
 */
export function getMe() {
    return request('GET', '/auth/me')
}

/**
 * Admin-only fallback login (most users authenticate via QR/link).
 * @param {string} username
 * @param {string} password
 * @return {Promise<import('./types.js').AuthLoginResponse>}
 */
export function login(username, password) {
    return request('POST', '/auth/login', {
        body: {username, password},
        skipAuth: true
    })
}

/**
 * Force-refresh the token (the client also does this in the background near expiry).
 * @return {Promise<{token: string}>}
 */
export function refresh() {
    return request('POST', '/auth/refresh')
}
